// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-import"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 22H20V7L15 2H4V12M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.0419 22.502L10.5021 19.0019L7.0419 15.502M9.3 19.002H1.99805","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileImportIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-import',
    ref,
    icon: element,
  },
));

FileImportIcon.displayName = 'FileImportIcon';

export default FileImportIcon;
